import { Component } from '@angular/core';
import { AnimateDirective } from '../directives/animate.directive';

@Component({
  selector: 'app-proof-strip-v2',
  standalone: true,
  imports: [AnimateDirective],
  template: `
    <section class="bg-white py-10 md:py-12">
      <div class="container mx-auto px-4 md:px-6">
        <div class="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-5xl mx-auto text-center mb-6">
          <div appAnimate class="flex flex-col gap-1">
            <span class="text-3xl md:text-4xl font-black text-[#FF5500]">+300</span>
            <span class="text-sm font-medium text-gray-700">empresas já protegidas</span>
          </div>
          <div appAnimate [delay]="100" class="flex flex-col gap-1">
            <span class="text-3xl md:text-4xl font-black text-[#FF5500]">+27 mil</span>
            <span class="text-sm font-medium text-gray-700">colaboradores monitorados</span>
          </div>
          <div appAnimate [delay]="200" class="flex flex-col gap-1">
            <span class="text-3xl md:text-4xl font-black text-[#FF5500]">97%</span>
            <span class="text-sm font-medium text-gray-700">de redução média de ações trabalhistas</span>
          </div>
          <div appAnimate [delay]="300" class="flex flex-col gap-1">
            <span class="text-3xl md:text-4xl font-black text-[#FF5500]">35%</span>
            <span class="text-sm font-medium text-gray-700">de aumento médio de produtividade</span>
          </div>
        </div>
        <p appAnimate [delay]="400" class="text-center text-sm text-gray-500 font-medium">
          Desde 2019 protegendo operações frigorificadas em todo o Brasil
        </p>
      </div>
    </section>
  `
})
export class ProofStripV2Component {}
